import React, {useState, useEffect } from "react";
import { Logo, Visibility, VisibilityOff } from "../assets/icons/Icons";
import { checkSessionExpirationAPI, userQRLoginExternal } from "../lib/apis/qrLogin";
import { toast } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";

const QrSignin = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [visible, setVisible] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [isExpired, setIsExpired] = useState(false);
  const encryptedSessionId = useParams().session_id;
  const navigate = useNavigate();

  useEffect(() => {
    const checkSessionExpiration = async () => {
      try {
        const response = await checkSessionExpirationAPI(encryptedSessionId||"");
        console.log(response);
        
        if (response?.status === 200) {
          if (response.data.result.expired) {
            setIsExpired(true);
          }
        }else{
          toast.error(response.data.error || "Error checking session status. Please try again.");
        }
        
       
      } catch (error) {
        console.error("Error checking session expiration:", error);
        setIsExpired(true);
      } finally {
        setIsLoading(false);
      }
    };

    if (encryptedSessionId) {
      checkSessionExpiration();
    }
  }, [encryptedSessionId, navigate]);

  const handleExternalSignin = async (e: React.FormEvent) => {
    e.preventDefault();
    if (encryptedSessionId && email && password) {
        const res = await userQRLoginExternal({
          encryptedSessionId,
          email,
          password,
        });
        console.log("Response from external login:", res);
        if (res?.status === 200) {
          setIsAuthenticated(true);
        } else {
          toast.error(res?.data?.error || "Login failed.");
        }
    } else {
      toast.error("Please fill all fields correctly.");
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center w-full h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }

  return (
    <div className="flex flex-row w-full h-screen">
      <div className="w-1/2 max-h-screen hidden md:flex">
        <img
          src={require("../assets/images/signin.png")}
          alt="Sign in"
          className="object-cover w-full max-h-screen"
        />
      </div>
      <div className="rounded-2xl border-[1px] border-white bg-white md:pt-20 px-10 lg:px-[156px] flex flex-col justify-center items-center w-full md:w-1/2">
        <div className={`${isAuthenticated || isExpired ? "hidden" : "block"} mx-36`}>
          <Logo />
        </div>
        {isExpired ? (
          <div className="flex flex-col items-center scale-[1.5]">
            <div className="expired-checkmark">
              <div className="check-icon">
                <span className="icon-line line-tip"></span>
                <span className="icon-line line-long"></span>
                <div className="icon-circle"></div>
                <div className="icon-fix"></div>
              </div>
            </div>
            <img src="https://cdn.dribbble.com/userupload/42148582/file/original-c7b955eaa954bbb81e9545660935fc2f.jpg?resize=1000x750&vertical=center" alt="Expired" className="w-1/2 object-cover" />
            <p className="text-red-500 text-sm">
              Session Expired!
            </p>
            <p className="text-[10px] mt-2">
              Please scan the QR code again
            </p>
          </div>
        ) : isAuthenticated ? (
          <div className="flex flex-col items-center scale-[1.5]">
            <div className="success-checkmark">
              <div className="check-icon">
                <span className="icon-line line-tip"></span>
                <span className="icon-line line-long"></span>
                <div className="icon-circle"></div>
                <div className="icon-fix"></div>
              </div>
            </div>
            <p className="text-green-500 text-sm mt-6 text-[#4CAF50]">
              Authentication Successful!
            </p>
            <p className="text-[10px] mt-2">
              Please check your TV for the login
            </p>
          </div>
        ) : (
          <form
            className="mt-28 flex flex-col w-full"
            onSubmit={(e) => handleExternalSignin(e)}
          >
            <p className="text-dark text-xl md:text-2xl font-bold text-left mb-11">
              Sign In for DocTrue
            </p>
            <p className="text-dark text-xs md:text-sm mb-2">Email Address</p>
            <input
              className="rounded-lg px-3 py-2 border-[0.5px] border-sbBorder w-full mb-4 focus:outline-none"
              placeholder="Enter Email Address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              minLength={0}
              id="email"
              required
            />
            <p className="text-dark text-xs md:text-sm mb-2">Password</p>
            <div className="flex justify-between items-center rounded-lg px-3 py-2 border-[0.5px] border-sbBorder w-full mb-9 bg-white">
              <input
                className="border-0 p-0 focus:ring-0 w-full mr-5 focus:outline-none"
                placeholder="8+ characters"
                type={visible ? "text" : "password"}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                minLength={8}
                id="password"
                required
              />
              <span
                onClick={() => setVisible(!visible)}
                className="cursor-pointer"
              >
                {visible ? <VisibilityOff /> : <Visibility />}
              </span>
            </div>
            <button
              type="submit"
              disabled={email.length === 0 && password.length === 0}
              className={`rounded-lg w-full text-sm font-semibold ${
                email.length !== 0 && password.length !== 0
                  ? "bg-sbTextHover text-white"
                  : "bg-signinButton text-signinText"
              }  p-4 mb-36`}
            >
              Sign In
            </button>
          </form>
        )}
      </div>
    </div>
  );
};

export default QrSignin;